import { createAction, props } from '@ngrx/store';
import { AuthResponse, LoginRequest, User } from '@klubovna/shared-models';

export interface UpdateProfileData {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  bio?: string;
}

export const login = createAction('[Auth] Login', props<{ credentials: LoginRequest }>());
export const loginSuccess = createAction('[Auth] Login Success', props<{ response: AuthResponse }>());
export const loginFailure = createAction('[Auth] Login Failure', props<{ error: string }>());

export const logout = createAction('[Auth] Logout');
export const logoutSuccess = createAction('[Auth] Logout Success');

export const forceLogout = createAction('[Auth] Force Logout');

export const initializeAuth = createAction('[Auth] Initialize');
export const initializeAuthFailure = createAction('[Auth] Initialize Failure');

export const validateToken = createAction('[Auth] Validate Token');
export const validateTokenSuccess = createAction('[Auth] Validate Token Success', props<{ user: User }>());
export const validateTokenFailure = createAction('[Auth] Validate Token Failure');

export const updateProfile = createAction('[Auth] Update Profile', props<{ data: UpdateProfileData }>());
export const updateProfileSuccess = createAction('[Auth] Update Profile Success', props<{ user: User }>());
export const updateProfileFailure = createAction('[Auth] Update Profile Failure', props<{ error: string }>());

export const uploadProfilePhoto = createAction('[Auth] Upload Profile Photo', props<{ file: File }>());
export const uploadProfilePhotoSuccess = createAction('[Auth] Upload Profile Photo Success', props<{ user: User }>());
export const uploadProfilePhotoFailure = createAction('[Auth] Upload Profile Photo Failure', props<{
  error: string
}>());

export const deleteProfilePhoto = createAction('[Auth] Delete Profile Photo');
export const deleteProfilePhotoSuccess = createAction('[Auth] Delete Profile Photo Success', props<{ user: User }>());
export const deleteProfilePhotoFailure = createAction('[Auth] Delete Profile Photo Failure', props<{
  error: string
}>());
